import { createAction, createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { AppState, DialogType, User } from "./types";

const initialState: AppState = {
  value: 0,
  isLoading: true,
  connected: false,
  jwt: null,
  user: null,
  dialog: null,
};

export const userConnectRequest = createAction(
  "app/userConnectRequest",
  (payload: any) => ({ payload })
);

export const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setUser: (
      state,
      action: PayloadAction<{
        jwt?: string;
        user: User | null;
      }>
    ) => {
      const { user, jwt } = action.payload;
      localStorage.setItem("jwt", jwt!);
      return {
        ...state,
        jwt,
        user,
        isLoading: false
      };
    },
    disconnect: (state) => {
      localStorage.removeItem("jwt");
      return {
        ...state,
        isLoading: false,
        connected: false,
        user: null,
        jwt: null,
      };
    },
    setLoaded: (state) => {
      return {
        ...state,
        isLoading: false,
      };
    },
    setActiveDialog: (state, action: PayloadAction<DialogType | null>) => {
      return {
        ...state,
        dialog: action.payload,
      };
    },
  },
});

export const {
  setUser,
  disconnect,
  setLoaded,
  setActiveDialog,
} = appSlice.actions;

export default appSlice.reducer;
